import { Link, useLocation } from 'react-router-dom'
import { IconContext } from 'react-icons'

const SidebarItem = ({ item, type = 0 }) => {
    const { pathname } = useLocation()

    const checkActive = item => {
        if (item.active) {
            return item.active.some(e => pathname.includes(e))
        }
        return pathname === item.url
    }

    return (
        <li>
            <Link
                className={`group relative flex items-center gap-2 py-2 px-3 pl-4 font-medium text-sm duration-300 ease-linear before:absolute before:left-0 before:h-0 before:w-1 before:bg-secondary before:duration-300 before:ease-linear hover:bg-strokedark hover:text-white hover:before:h-full ${
                    type === 0 ? 'text-gray' : 'text-black dark:text-gray'
                } ${checkActive(item) && 'bg-strokedark text-white before:!h-full'}`}
                to={item.url}
            >
                {item.icon && <IconContext.Provider value={{ size: '20' }}>{item.icon}</IconContext.Provider>}
                {item.text}
            </Link>
        </li>
    )
}

export default SidebarItem
